export default __webpack_public_path__ + "static/media/Muli-Regular.9249d093.ttf";